import { mergeDeepRight, propEq } from 'ramda'
import React from 'react'

import { Bar } from '@ant-design/plots'

import { useColor, useColors } from '../../../kiti/components/theme/_hooks/colors'

const BarChart = ({ data, xField, yField, color, ...props }) => {
  const colors = useColors()
  color = useColor(color)

  const config = mergeDeepRight(
    {
      data,
      xField,
      yField,
      autoFit: true,
      animation: false,
      seriesField: '',
      barStyle: {
        radius: [5, 5, 0, 0]
      },
      color: ({ name }) => {
        // const { percentage } = data.find(propEq('name', name))
        // if (percentage >= 50) return colors.green
        // if (percentage <= 5) return colors.red
        return color
      },
      legend: false,
      tooltip: false,
      xAxis: false,
      label: {
        position: 'middle',
        formatter: ({ percentage }) => percentage + '%'
      }
    },
    props
  )

  return <Bar {...config} />
}

export default BarChart
